<template>
 <div id="app" class="app" :style="{display:'block'}">
    <config-menu v-if="isSignedIn" 
      :show-events="showEvents"
      :show-event-names="showEventNames"
      v-on:menu-visibility-changed="menuIsVisible = $event"
      v-on:show-events-changed="showEvents = $event"
      v-on:show-event-names-changed="showEventNames = $event"
      v-on:change-calendar-clicked="calendarId = null"
      v-on:sign-out-clicked="signOut()"/>

    <div class="app__main-screens" :class="{'app__main-screens--menu-visible': menuIsVisible}">
      <sign-in v-if="!isSignedIn || !calendarId" :g-cal-api="gCalApi" :is-signed-in="isSignedIn" v-on:calendar-id-selected="calendarId = $event"/>
      <event-display v-if="isSignedIn && calendarId && showEvents" :g-cal-api="gCalApi" :calendar-id="calendarId" :events-refresh-interval-ms="eventsRefreshIntervalMs" 
        :warn-before-end-ms="warnBeforeEndMs" :ready-to-fetch-events="readyToFetchEvents" :now="now" :show-event-names="showEventNames" :allow-check-in="true"/>
    </div>
  </div>
</template>

<script>
import SignIn from './components/SignIn.vue';
import EventDisplay from './components/EventDisplay.vue';
import ConfigMenu from './components/ConfigMenu.vue';

export default {

  name: 'RoomDisplay',
  components: {
    'sign-in': SignIn,
    'event-display': EventDisplay,
    'config-menu': ConfigMenu
  },

  data: function() {
    return {
      gCalConfig: {
        apiKey: 'AIzaSyDkO-UALu5ZGgvJHtMn-YV0NCM_EUog0Fk',
        clientId: '843241238010-um58u584is5vj5ulaql6d8ihht8frk23.apps.googleusercontent.com',
        discoveryDocs: [
          "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
          "https://people.googleapis.com/$discovery/rest?version=v1",
          "https://www.googleapis.com/discovery/v1/apis/admin/directory_v1/rest"
        ],
        scopes: 'email https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/admin.directory.user.readonly'
      },
      isSignedIn: false,
      calendarId: null,
      uiRefreshIntervalMs: 1000, // 1 second
      uiRefreshInterval: null,
      eventsRefreshIntervalMs: 10*1000, // 10 seconds
      warnBeforeEndMs: 2*60*1000, // 2 minutes     
      now: new Date(), 
      gCalApi: null,
      menuIsVisible: false,
      showEvents: true,
      showEventNames: true
    };
  },
  watch: {
    isSignedIn: function() {
      if(!this.isSignedIn) {
        return;
      }

      const app = this;
      // Refresh UI and events periodically
      this.uiRefreshInterval = setInterval(function() {
        app.now = new Date();
      }, this.uiRefreshIntervalMs);

      this.loadCookies();
    },
    calendarId: function() {
      if(this.calendarId) {
        this.setCookie('calendarId', this.calendarId);
      } else {
        this.deleteCookie('calendarId');
      }
    }
  },
  computed: {
    readyToFetchEvents: function() {
      return this.isSignedIn && this.calendarId != null;
    }
  },
  methods: {
    loadCookies: function() {
      this.calendarId = this.readCookie('calendarId');
    },
    setCookie: function(name, value) {
      let d = new Date();                
      d.setTime(d.getTime() + (365000*24*60*60*1000));
      let expires = `expires=${d.toUTCString()}`;
      document.cookie = `${name}=${value};${expires};path=/`;
    },
    readCookie: function(name) {
      let nameEQ = name + "=";
      let ca = document.cookie.split(';');
      for(let i=0;i < ca.length;i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1,c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length,c.length);
        }
      }
      return null;
    },  
    deleteCookie: function(name) {
      document.cookie = `${name}=deleting;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
    },
    initClient: function() {
      const app = this;

      this.gCalApi.client.init({
        apiKey: this.gCalConfig.apiKey,
        clientId: this.gCalConfig.clientId,
        discoveryDocs: this.gCalConfig.discoveryDocs,
        scope: this.gCalConfig.scopes
      }).then(function () {
        // Listen for sign-in state changes.
        app.gCalApi.auth2.getAuthInstance().isSignedIn.listen(app.updateSigninStatus);

        // Handle the initial sign-in state.
        app.updateSigninStatus(app.gCalApi.auth2.getAuthInstance().isSignedIn.get());
      }, function(error) {
        console.log(error);
      });
    },
    updateSigninStatus: function(isSignedIn) {
      this.isSignedIn = isSignedIn;
    },
    signOut: function() {
      clearInterval(this.uiRefreshInterval);      
      this.gCalApi.auth2.getAuthInstance().signOut();
      this.calendarId = null;
      this.events = [];
    }  
  },  
  mounted: function() {
    const app = this;
    const gApiScript = document.createElement('script');
    gApiScript.setAttribute('src', 'https://apis.google.com/js/api.js');
    gApiScript.addEventListener('load', function() {    
      window.gapi.load('client:auth2', app.initClient);
      app.gCalApi = window.gapi;       
    });
    document.head.appendChild(gApiScript);
  }
}
</script>

<style lang="scss" scoped>
.app__main-screens {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  transform: translateX(0);
  transition: transform 0.2s;

  &--menu-visible {
    transform: translateX(33vw);
  }
}
</style>
